const initialState = {
  list: [],
  loading: false,
  error: null
}

const popupFormSubmissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "POPUP_FORM_SUBMISSION_LOADING":
      return { ...state, loading: true, error: null }
    case "GET_ALL_POPUP_FORM_SUBMISSIONS": {
      const payload = action.data
      const normalized =
        (Array.isArray(payload?.data?.items) && payload.data.items) ||
        (Array.isArray(payload?.data?.data) && payload.data.data) ||
        (Array.isArray(payload?.data) && payload.data) ||
        (Array.isArray(payload?.items) && payload.items) ||
        (Array.isArray(payload) && payload) ||
        []
      return { ...state, list: normalized, loading: false, error: null }
    }
    case "POPUP_FORM_SUBMISSION_ERROR":
      return { ...state, error: action.payload, loading: false }
    default:
      return state
  }
}

export default popupFormSubmissionReducer

